module.exports = __webpack_public_path__ + "static/media/Adriana_Maria_Barradas_Bravo_.5971056d.png";